module.exports = __webpack_public_path__ + "static/img/ar_logo.245da817.png";